import { http } from './client';
import type { EscalationConfigPatch, EscalationConfigView } from './types';

export const escalationApi = {
  async get(botId: string): Promise<EscalationConfigView> {
    const res = await http.get<EscalationConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/escalation`,
    );
    return res.data;
  },
  async update(botId: string, patch: EscalationConfigPatch): Promise<EscalationConfigView> {
    const res = await http.put<EscalationConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/escalation`,
      patch,
    );
    return res.data;
  },
};
